import { render, staticRenderFns } from "./ContentClinic.vue?vue&type=template&id=457fe864&scoped=true"
import script from "./ContentClinic.vue?vue&type=script&lang=js"
export * from "./ContentClinic.vue?vue&type=script&lang=js"
import style0 from "./ContentClinic.vue?vue&type=style&index=0&id=457fe864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457fe864",
  null
  
)

export default component.exports